import api from './api';

// Portal session issued by the backend after PIN validation. Kept in memory only:
// reloading the page asks for the PIN again.
let portalSession = null;

const portalSessionHeaders = () => {
  if (!portalSession) {
    throw new Error('Sesión del portal no iniciada: valida el PIN primero');
  }
  return { headers: { 'X-Portal-Session': portalSession } };
};

export const clientService = {
  // Public portal endpoints (no auth required)
  validatePortalAccess: async (token, pin) => {
    const response = await api.post(`/clients/portal/${token}/validate`, { pin });
    portalSession = response.data?.data?.session || null;
    return response.data;
  },

  // Pre-auth: Only returns name and logo (safe to call before PIN)
  getPortalData: async (token) => {
    const response = await api.get(`/clients/portal/${token}`);
    return response.data;
  },

  // Post-auth: Returns full client data including projects (call after PIN validated)
  getPortalDataAuthenticated: async (token) => {
    const response = await api.get(`/clients/portal/${token}/data`, portalSessionHeaders());
    return response.data;
  },

  getPortalProject: async (token, projectId) => {
    const response = await api.get(`/clients/portal/${token}/projects/${projectId}`, portalSessionHeaders());
    return response.data;
  },

  // Admin endpoints
  getAll: async (params = {}) => {
    const response = await api.get('/clients', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/clients/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/clients', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/clients/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/clients/${id}`);
    return response.data;
  },

  generateToken: async (id) => {
    const response = await api.post(`/clients/${id}/generate-token`);
    return response.data;
  },

  revokeToken: async (id) => {
    const response = await api.delete(`/clients/${id}/revoke-token`);
    return response.data;
  },
};

export default clientService;
